const updateAssociationName = (name) => {
  switch (name) {
    case "affiliateMember":
      return "AFFILIATE_MEMBER";
    case "affiliateMemberDetail":
      return "AFFILIATE_MEMBER_DETAIL";
    case "affiliateMemberAddress":
      return "AFFILIATE_MEMBER_ADDRESS";
    default:
      return name;
  }
}

export default updateAssociationName;
